/* eslint-disable jsx-a11y/iframe-has-title */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Used for displaying images inserted into questions:
 * - main illustration that can be added on top of every question
 */
class EmbedDisplay extends React.PureComponent {
    static propTypes = {
        model: PropTypes.object.isRequired,
        reportReady: PropTypes.func,
    };

    static defaultProps = {
        reportReady: () => undefined,
    };

    onLoad = () => { this.props.reportReady(true); };

    render() {
        const { url, isMainMedia, width, height, isPreRender, extraAttributes } = this.props.model;
        const globalClass = isMainMedia ? 'main-media qti-embed' : 'qti-embed';
        const style = {};

        if (isPreRender) {
            return null;
        }

        if (width > 0) {
            style.width = `${width}px`;
        }
        if (height > 0) {
            style.height = `${height}px`;
        }

        return (
            <iframe
                className={globalClass}
                onLoad={this.onLoad}
                sandbox="allow-presentation allow-scripts allow-same-origin"
                src={url}
                style={style}
                {...extraAttributes}
            />
        );
    }
}

export default EmbedDisplay;
